import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_3089b76d from 'nuxt_plugin_sentryserver_3089b76d' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_6a5f7436 from 'nuxt_plugin_sentryclient_6a5f7436' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_d750435e from 'nuxt_plugin_cookieuniversalnuxt_d750435e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuewaitplugin_9aa578ca from 'nuxt_plugin_vuewaitplugin_9aa578ca' // Source: ./vue-wait-plugin.js (mode: 'all')
import nuxt_plugin_templatesplugin562706c8_0b873978 from 'nuxt_plugin_templatesplugin562706c8_0b873978' // Source: ./templates.plugin.562706c8.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_48ee8c87 from 'nuxt_plugin_nuxtsvgsprite_48ee8c87' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_pluginrouting_6a422d7d from 'nuxt_plugin_pluginrouting_6a422d7d' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_23de11dc from 'nuxt_plugin_pluginmain_23de11dc' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_logger_3637d829 from 'nuxt_plugin_logger_3637d829' // Source: ../src/plugins/logger.ts (mode: 'all')
import nuxt_plugin_amplifyapi_15c03ae0 from 'nuxt_plugin_amplifyapi_15c03ae0' // Source: ../src/plugins/amplify-api.ts (mode: 'all')
import nuxt_plugin_i18nserver_3b281c2e from 'nuxt_plugin_i18nserver_3b281c2e' // Source: ../src/plugins/i18n.server.ts (mode: 'server')
import nuxt_plugin_i18nclient_5522aab4 from 'nuxt_plugin_i18nclient_5522aab4' // Source: ../src/plugins/i18n.client.ts (mode: 'client')
import nuxt_plugin_dailychat_a77310a6 from 'nuxt_plugin_dailychat_a77310a6' // Source: ../src/plugins/daily-chat.ts (mode: 'all')
import nuxt_plugin_components_567e580a from 'nuxt_plugin_components_567e580a' // Source: ../src/plugins/components (mode: 'all')
import nuxt_plugin_route_58147a38 from 'nuxt_plugin_route_58147a38' // Source: ../src/plugins/route.ts (mode: 'all')
import nuxt_plugin_chatclient_fd9bf940 from 'nuxt_plugin_chatclient_fd9bf940' // Source: ../src/plugins/chat.client.ts (mode: 'client')
import nuxt_plugin_notifications_b9f3298e from 'nuxt_plugin_notifications_b9f3298e' // Source: ../src/plugins/notifications.ts (mode: 'all')
import nuxt_plugin_notificationsclient_031424f0 from 'nuxt_plugin_notificationsclient_031424f0' // Source: ../src/plugins/notifications.client.ts (mode: 'client')
import nuxt_plugin_directivesclient_38b8040c from 'nuxt_plugin_directivesclient_38b8040c' // Source: ../src/plugins/directives.client.ts (mode: 'client')
import nuxt_plugin_storyblok_761bf9b4 from 'nuxt_plugin_storyblok_761bf9b4' // Source: ../src/plugins/storyblok.ts (mode: 'all')
import nuxt_plugin_storyblokclient_29cdfe0a from 'nuxt_plugin_storyblokclient_29cdfe0a' // Source: ../src/plugins/storyblok.client.ts (mode: 'client')
import nuxt_plugin_analyticsclient_f04326b4 from 'nuxt_plugin_analyticsclient_f04326b4' // Source: ../src/plugins/analytics.client.ts (mode: 'client')
import nuxt_plugin_authserver_5163c990 from 'nuxt_plugin_authserver_5163c990' // Source: ../src/plugins/auth.server.ts (mode: 'server')
import nuxt_plugin_authclient_7194a9b0 from 'nuxt_plugin_authclient_7194a9b0' // Source: ../src/plugins/auth.client.ts (mode: 'client')
import nuxt_plugin_browserclient_52334cc8 from 'nuxt_plugin_browserclient_52334cc8' // Source: ../src/plugins/browser.client.ts (mode: 'client')
import nuxt_plugin_vuedatepickerclient_16704dab from 'nuxt_plugin_vuedatepickerclient_16704dab' // Source: ../src/plugins/vue-datepicker.client.ts (mode: 'client')
import nuxt_plugin_componentuid_e7f96cbe from 'nuxt_plugin_componentuid_e7f96cbe' // Source: ../src/plugins/component-uid.ts (mode: 'all')
import nuxt_plugin_validatetenantserver_0c699dae from 'nuxt_plugin_validatetenantserver_0c699dae' // Source: ../src/plugins/validate-tenant.server.ts (mode: 'server')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"hid":"recaptcha","src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fenterprise.js?render=6LfSL9gaAAAAAGDcjuSjguhUZr6Cuge407xclTeS","defer":true}],"title":"YouGov Chat - What The World Thinks","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{},{"hid":"description","name":"description","content":"Join today and share your views on all the latest global events and news to understand how people view the world."},{"hid":"name","itemprop":"name","content":"YouGov Chat - What The World Thinks"},{"hid":"description-itemprop","itemprop":"description","content":"Join today and share your views on all the latest global events and news to understand how people view the world."},{"property":"og:type","content":"website"},{"hid":"og-title","property":"og:title","content":"YouGov Chat - What The World Thinks"},{"hid":"og-description","property":"og:description","content":"Join today and share your views on all the latest global events and news to understand how people view the world."},{"property":"og:site_name","content":"YouGov Chat"},{"hid":"og-url","property":"og:url","content":"https:\u002F\u002Fwww.yougov.chat"},{"property":"twitter:card","content":"summary_large_image"},{"hid":"twitter-title","property":"twitter:title","content":"YouGov Chat - What The World Thinks"},{"hid":"twitter-description","property":"twitter:description","content":"Join today and share your views on all the latest global events and news to understand how people view the world."},{"hid":"twitter-image","property":"twitter:image","content":"https:\u002F\u002Fwww.yougov.chat\u002Fimages\u002Fshare.png"},{"hid":"app-title","name":"apple-mobile-web-app-title","content":"YouGov Chat - What The World Thinks"},{"hid":"app-name","name":"application-name","content":"YouGov Chat - What The World Thinks"},{"name":"theme-color","content":"#ffffff"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"mobile-web-app-status-bar-style","content":"default"},{"name":"msapplication-TileImage","content":"https:\u002F\u002Fwww.yougov.chat\u002Fimages\u002Fmstile-150x150.png"},{"name":"msapplication-TileColor","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_3089b76d === 'function') {
    await nuxt_plugin_sentryserver_3089b76d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_6a5f7436 === 'function') {
    await nuxt_plugin_sentryclient_6a5f7436(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d750435e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d750435e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuewaitplugin_9aa578ca === 'function') {
    await nuxt_plugin_vuewaitplugin_9aa578ca(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin562706c8_0b873978 === 'function') {
    await nuxt_plugin_templatesplugin562706c8_0b873978(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_48ee8c87 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_48ee8c87(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6a422d7d === 'function') {
    await nuxt_plugin_pluginrouting_6a422d7d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_23de11dc === 'function') {
    await nuxt_plugin_pluginmain_23de11dc(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_3637d829 === 'function') {
    await nuxt_plugin_logger_3637d829(app.context, inject)
  }

  if (typeof nuxt_plugin_amplifyapi_15c03ae0 === 'function') {
    await nuxt_plugin_amplifyapi_15c03ae0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_i18nserver_3b281c2e === 'function') {
    await nuxt_plugin_i18nserver_3b281c2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18nclient_5522aab4 === 'function') {
    await nuxt_plugin_i18nclient_5522aab4(app.context, inject)
  }

  if (typeof nuxt_plugin_dailychat_a77310a6 === 'function') {
    await nuxt_plugin_dailychat_a77310a6(app.context, inject)
  }

  if (typeof nuxt_plugin_components_567e580a === 'function') {
    await nuxt_plugin_components_567e580a(app.context, inject)
  }

  if (typeof nuxt_plugin_route_58147a38 === 'function') {
    await nuxt_plugin_route_58147a38(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chatclient_fd9bf940 === 'function') {
    await nuxt_plugin_chatclient_fd9bf940(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_b9f3298e === 'function') {
    await nuxt_plugin_notifications_b9f3298e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notificationsclient_031424f0 === 'function') {
    await nuxt_plugin_notificationsclient_031424f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directivesclient_38b8040c === 'function') {
    await nuxt_plugin_directivesclient_38b8040c(app.context, inject)
  }

  if (typeof nuxt_plugin_storyblok_761bf9b4 === 'function') {
    await nuxt_plugin_storyblok_761bf9b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_storyblokclient_29cdfe0a === 'function') {
    await nuxt_plugin_storyblokclient_29cdfe0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticsclient_f04326b4 === 'function') {
    await nuxt_plugin_analyticsclient_f04326b4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_authserver_5163c990 === 'function') {
    await nuxt_plugin_authserver_5163c990(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authclient_7194a9b0 === 'function') {
    await nuxt_plugin_authclient_7194a9b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_browserclient_52334cc8 === 'function') {
    await nuxt_plugin_browserclient_52334cc8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedatepickerclient_16704dab === 'function') {
    await nuxt_plugin_vuedatepickerclient_16704dab(app.context, inject)
  }

  if (typeof nuxt_plugin_componentuid_e7f96cbe === 'function') {
    await nuxt_plugin_componentuid_e7f96cbe(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_validatetenantserver_0c699dae === 'function') {
    await nuxt_plugin_validatetenantserver_0c699dae(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
